module.exports = __webpack_public_path__ + "img/34d-config-modelos-doc-wizard-reincidencia.6aa97485.png";